export default {
  editor: null,
};
